import { useEffect } from "react";

export default function Animation({ children, effect, elementAppear }) {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(effect);
          observer.unobserve(entry.target);
        }
      });
    });

    document.querySelectorAll(elementAppear).forEach((element) => {
      observer.observe(element);
    });
  }, []);

  return <>{children}</>;
}
